import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

_pushScopeId("data-v-79081fd4");

var _hoisted_1 = {
  key: 0,
  class: "envelopes-wrapper"
};
var _hoisted_2 = {
  class: "envelopes-container"
};
var _hoisted_3 = {
  key: 0,
  class: "envelopes-title before"
};
var _hoisted_4 = {
  key: 1,
  class: "envelopes-title"
};
var _hoisted_5 = {
  key: 1,
  class: "notice"
};
var _hoisted_6 = {
  key: 2,
  class: "envelopes-title after"
};
var _hoisted_7 = {
  key: 3,
  class: "envelopes-title after"
};
var _hoisted_8 = {
  key: 1,
  class: "envelopes-tip"
};
var _hoisted_9 = {
  key: 2,
  class: "envelopes-tip"
};
var _hoisted_10 = {
  key: 0,
  class: "envelopes-tip"
};
var _hoisted_11 = {
  key: 1,
  class: "envelopes-tip"
};
var _hoisted_12 = {
  key: 0,
  class: "envelopes-tip"
};
var _hoisted_13 = {
  key: 1,
  class: "envelopes-tip"
};
var _hoisted_14 = {
  class: "wrapper_buttons"
};
var _hoisted_15 = {
  key: 0,
  class: "envelopes-button before down"
};

var _hoisted_16 = /*#__PURE__*/_createTextVNode(" 后开抢 ");

var _hoisted_17 = {
  key: 0,
  class: "envelopes-button after down"
};
var _hoisted_18 = {
  key: 0
};

var _hoisted_19 = /*#__PURE__*/_createTextVNode(" 后开抢 ");

var _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode("已抢完"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("span", null, "明天再来吧")], -1);

var _hoisted_21 = [_hoisted_20];
var _hoisted_22 = {
  key: 1,
  class: "envelopes-button after info"
};

var _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode("已抢完"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("span", null, "明天再来吧")], -1);

var _hoisted_24 = [_hoisted_23];
var _hoisted_25 = {
  key: 3,
  class: "envelopes-button after info"
};

var _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode("已抢完"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("span", null, "明天再来吧")], -1);

var _hoisted_27 = [_hoisted_26];
var _hoisted_28 = {
  class: "container"
};
var _hoisted_29 = {
  class: "content-wrapper detail"
};
var _hoisted_30 = {
  class: "content"
};

var _hoisted_31 = /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "明细", -1);

var _hoisted_32 = /*#__PURE__*/_createElementVNode("div", {
  class: "type-wrapper"
}, [/*#__PURE__*/_createElementVNode("span", null, "昵称"), /*#__PURE__*/_createElementVNode("span", null, "积分数")], -1);

var _hoisted_33 = {
  class: "list-wrapper"
};

var _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  class: "container"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-wrapper"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "活动规则"), /*#__PURE__*/_createElementVNode("p", {
  class: "content-info rule-wrapper"
}, [/*#__PURE__*/_createElementVNode("b", null, "1.“天天抢积分”说明"), /*#__PURE__*/_createTextVNode(), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 1.1相同IP、设备、账号活动期间每天仅可参与一次抢积分活动，开抢时间获得随机奖励积分，抢完为止；"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 1.2参与活动获得的积分可点击“积分商城兑好礼”按钮后查看积分明细；"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 1.3活动结束后通过审核不是真实用户的取消活动期间所得所有积分（包括并不限于马甲账号、机器账号等第一电动定义的非正常用户）；"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("b", null, "2.“100万新年礼 呼朋唤友随心抢”说明"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 2.1同一个设备同一个IP仅可使用1个登录账号参与本次活动；"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 2.2此活动选择想要的奖品后，邀请好友必须在规定的时间内完成任务规定的好友数，邀请的好友必须下载第一电动APP，注册登录并修改昵称后的用户确定为邀请成功，邀请的好友运营审核通过后，提交收件人的姓名、电话、地址提交审核通过后等待奖品邮寄；"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 2.3此活动选择想要的奖品，在活动时间未结束时点击“结束任务”后自愿放弃任务，对于已经成功邀请的用户数不予以任何补偿；超过规定时间任务未完成，挑战失败后，按单个用户200积分给予返还到您的积分内；"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 2.4被邀请的好友在注册下载第一电动APP并修改昵称后审核为真实用户的获得200积分的奖励；"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 2.5成功兑换活动奖品后，活动未结束亦可继续选择奖品参与新的一轮的邀请挑战任务；"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 2.6所有用户获得的奖品和最终未完成阶段已邀请用户的奖励积分均需审核已邀请用户后才可获得，邀请用户及被邀请用户不是真实用户、马甲号等不是真实用户的活动参与者取消活动期间一切活动奖品和积分资格，以第一电动运营最终定义的为准；"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("b", null, "奖品兑换说明："), /*#__PURE__*/_createTextVNode(" 用户成功兑换奖品后，在活动结束后统一安排寄送，如用户未能在本活动领取有效期结束前于相关页面填写用户的收件信息等，第一电动将视为用户自动放弃获得的奖品；如用户因填写的收件信息错误或无法投递，或因承运人原因导致遗失，致使用户未能收到奖品，第一电动不承担责任，因此请用户及时填写您正确、有效的收件信息。"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("b", null, "3.其他说明："), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 3.1 本次活动及活动奖品与苹果公司无关；"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 3.2 本次活动欢迎用户参与，当第一电动发现用户有作弊等非正常形式参与活动时，会采取以下措施：包括但不限于限制登录、封禁账号、停止发奖、收回奖品并保留追究法律责任的权利。"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 3.3 如果任务活动相关问题，请及时邮件沟通，内容必须包含个人信息（姓名、电话、地址）发送至zhangyu@d1ev.com，注：邮件标题为“迎新春好礼嗨翻天邀请好友”活动问题反馈”。"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("b", null, "4.法律条款："), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" “100万新年礼 呼朋唤友随心抢”活动为第一电动客户端平台活动，您在参与本次活动之前，请认真阅读并充分理解理解本次活动的活动规则及法律条款，如您参与本次活动，则应视为您已完成阅读、充分理解并同意活动规则及相关条款，如您对活动规则及相关条款的任何部分存在异议，或者无法准确理解，请不要参与此活动。"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 4.1 本活动的活动规则及条款由本平台设定，活动期间平台可自主的对活动规则及条款进行变动及调整，如不同意变更，应停止参与活动；"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 4.2为了本次活动的公平性，您不应以任何作弊或其他不正当的行为（包括但并不限于恶意刷等任何的技术或人工手段）参与本次活动，不应利用系统漏洞来获得不正当的非法利益。本平台不承认上述不正当行为和利益的效力，如经发现本平台取消参与本次活动资格和因参与本次活动获得的任何奖励。"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 4.3参与本次活动的所有行为，应符合法律法规、相关政策及相关平台的规范。否则一经发现取消所有参与资格及奖品资格；"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 4.4本平台有权依照自主决定随时修改、暂停、终止本次活动及相关服务而无需为此做出任何补偿、赔偿或承担任何责任。"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 4.5本次活动的相关数据、记录，包括但不限于本次活动中的任何积分数量、邀请数量、奖品数量以及有效期起止时间等数据将以本平台统计的数据为准。"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 4.6您不应该通过买卖本次活动的邀请人数、账号、奖品等其他方式，利用本活动牟取利益，如经发现本平台有权取消其参与活动的资格及因参与本次活动获得的所有奖励。"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("br")])])])], -1);

var _hoisted_35 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn-fs.touchev.com/d/file/special/2023/spring-activity-2/open-envelopes.png!w480",
  alt: ""
}, null, -1);

var _hoisted_36 = [_hoisted_35];

var _hoisted_37 = /*#__PURE__*/_createElementVNode("p", null, "抢到了", -1);

var _hoisted_38 = {
  class: "number"
};

var _hoisted_39 = /*#__PURE__*/_createElementVNode("p", null, "积分", -1);

var _hoisted_40 = /*#__PURE__*/_createElementVNode("p", {
  class: "tip"
}, "[已存入我的积分]", -1);

var _hoisted_41 = /*#__PURE__*/_createTextVNode(" 查看明细 ");

var _hoisted_42 = /*#__PURE__*/_createElementVNode("p", {
  class: "fail-tip"
}, "明天再来吧", -1);

var _hoisted_43 = /*#__PURE__*/_createTextVNode(" 查看明细 ");

var _hoisted_44 = {
  class: "dialog-info-wrapper"
};
var _hoisted_45 = {
  class: "title"
};
var _hoisted_46 = {
  class: "dialog-button-wrapper"
};

var _hoisted_47 = /*#__PURE__*/_createTextVNode("关闭");

var _hoisted_48 = /*#__PURE__*/_createTextVNode("去认证");

_popScopeId();

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_swipe_item = _resolveComponent("van-swipe-item");

  var _component_van_swipe = _resolveComponent("van-swipe");

  var _component_van_notice_bar = _resolveComponent("van-notice-bar");

  var _component_van_count_down = _resolveComponent("van-count-down");

  var _component_MyInvitationItem = _resolveComponent("MyInvitationItem");

  var _component_van_empty = _resolveComponent("van-empty");

  var _component_van_list = _resolveComponent("van-list");

  var _component_van_action_sheet = _resolveComponent("van-action-sheet");

  var _component_van_overlay = _resolveComponent("van-overlay");

  var _component_van_button = _resolveComponent("van-button");

  return $options.notEmpty ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$data.info.status === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$options.statusText.code === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($options.statusText.text), 1)) : _createCommentVNode("", true), $options.statusText.code === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [!$data.recordList.length ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createTextVNode(_toDisplayString($options.statusText.text), 1)], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_van_notice_bar, {
    style: {
      "height": "24px"
    },
    color: "#fff",
    background: "transparent",
    scrollable: $data.recordList.length === 1 ? true : false
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_swipe, {
        vertical: "",
        class: "notice-swipe",
        autoplay: 5000,
        "show-indicators": false
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.recordList, function (item) {
            return _openBlock(), _createBlock(_component_van_swipe_item, null, {
              default: _withCtx(function () {
                return [_createElementVNode("span", null, _toDisplayString(item.nickName), 1), _createTextVNode("抢了" + _toDisplayString(item.integral) + "积分 ", 1)];
              }),
              _: 2
            }, 1024);
          }), 256))];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["scrollable"])]))])) : _createCommentVNode("", true), $options.statusText.code === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($options.statusText.text), 1)) : _createCommentVNode("", true), $options.statusText.code === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($options.statusText.text), 1)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), $options.statusText.code === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($options.start) + "开抢", 1)) : _createCommentVNode("", true), $options.statusText.code === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($options.statusText.text), 1)) : _createCommentVNode("", true), $options.statusText.code === 2 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [$options.nextNotEmpty ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($options.NextStart) + "后开抢", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_11, "已抢完"))], 64)) : _createCommentVNode("", true), $options.statusText.code === 3 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 4
  }, [$options.nextNotEmpty ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString($options.NextStart) + "后开抢", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_13, "已抢完"))], 64)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "banner-rule",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $data.dialogShow2 = true;
    })
  }), _createElementVNode("div", {
    class: "envelopes-detail",
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.checkDetail && $options.checkDetail.apply($options, arguments);
    })
  }), _createElementVNode("div", _hoisted_14, [$options.statusText.code === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [$options.inOneDay ? (_openBlock(), _createBlock(_component_van_count_down, {
    key: 0,
    class: "count-down",
    time: $options.lastSectionTime,
    format: "HH 时 mm 分 ss 秒",
    onFinish: $options.onFinishCountDown
  }, null, 8, ["time", "onFinish"])) : (_openBlock(), _createBlock(_component_van_count_down, {
    key: 1,
    class: "count-down",
    time: $options.lastSectionTime,
    format: "DD 天",
    onFinish: $options.onFinishCountDown
  }, null, 8, ["time", "onFinish"])), _hoisted_16])) : _createCommentVNode("", true), $options.statusText.code === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$data.info.isMe === 1 || $data.redPacket === 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "envelopes-button after",
    onClick: _cache[2] || (_cache[2] = function () {
      return $options.checkDetail && $options.checkDetail.apply($options, arguments);
    })
  })) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "envelopes-button",
    onClick: _cache[3] || (_cache[3] = function () {
      return $options.getRedpacket && $options.getRedpacket.apply($options, arguments);
    })
  }))], 64)) : _createCommentVNode("", true), $options.statusText.code === 2 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [$options.inOneDay ? (_openBlock(), _createElementBlock("div", _hoisted_17, [$options.nextNotEmpty ? (_openBlock(), _createElementBlock("p", _hoisted_18, [_createVNode(_component_van_count_down, {
    class: "count-down",
    time: $options.NextLastSectionTime,
    format: "HH 时 mm 分 ss 秒",
    onFinish: $options.onFinishCountDown
  }, null, 8, ["time", "onFinish"]), _hoisted_19])) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "envelopes-button after info",
    onClick: _cache[4] || (_cache[4] = function () {
      return $options.checkDetail && $options.checkDetail.apply($options, arguments);
    })
  }, _hoisted_21))])) : (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))], 64)) : _createCommentVNode("", true), $options.statusText.code === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27)) : _createCommentVNode("", true)])]), _createVNode(_component_van_action_sheet, {
    show: $data.dialogShow1,
    "onUpdate:show": _cache[6] || (_cache[6] = function ($event) {
      return $data.dialogShow1 = $event;
    }),
    title: " "
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_hoisted_31, _hoisted_32, _createElementVNode("div", _hoisted_33, [_createVNode(_component_van_list, {
        loading: $data.recordInfo.loading,
        "onUpdate:loading": _cache[5] || (_cache[5] = function ($event) {
          return $data.recordInfo.loading = $event;
        }),
        finished: $data.recordInfo.finished,
        "finished-text": "没有更多了",
        onLoad: $options.onLoad
      }, {
        default: _withCtx(function () {
          return [$data.recordList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList($data.recordList, function (item) {
            return _openBlock(), _createBlock(_component_MyInvitationItem, {
              item: item,
              key: item.id
            }, null, 8, ["item"]);
          }), 128)) : (_openBlock(), _createBlock(_component_van_empty, {
            key: 1,
            class: "custom-image",
            image: "https://cdn-fs.touchev.com/d/file/special/2023/spring-activity-2/content-null.png!w480",
            description: "目前还没有～"
          }))];
        }),
        _: 1
      }, 8, ["loading", "finished", "onLoad"])])])])])];
    }),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_action_sheet, {
    show: $data.dialogShow2,
    "onUpdate:show": _cache[7] || (_cache[7] = function ($event) {
      return $data.dialogShow2 = $event;
    }),
    title: " "
  }, {
    default: _withCtx(function () {
      return [_hoisted_34];
    }),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_overlay, {
    show: $data.show,
    "z-index": "3",
    onClick: _cache[9] || (_cache[9] = function ($event) {
      return $data.show = false;
    })
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", {
        class: _normalizeClass(["overlay-wrapper open-envelopes", {
          active: $data.show
        }]),
        onClick: _cache[8] || (_cache[8] = _withModifiers(function () {}, ["stop"]))
      }, _hoisted_36, 2)];
    }),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_overlay, {
    show: $data.showSuccess,
    "z-index": "3",
    onClick: _cache[11] || (_cache[11] = function ($event) {
      return $data.showSuccess = false;
    })
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", {
        class: "overlay-wrapper success",
        onClick: _cache[10] || (_cache[10] = _withModifiers(function () {
          return $options.checkDetail && $options.checkDetail.apply($options, arguments);
        }, ["stop"]))
      }, [_hoisted_37, _createElementVNode("p", _hoisted_38, _toDisplayString($data.integral), 1), _hoisted_39, _hoisted_40, _createVNode(_component_van_button, {
        class: "button-wrapper",
        block: "",
        type: "primary",
        size: "normal",
        round: "",
        color: "linear-gradient(180deg, #FF9D9D 0%, #CF0000 100%)"
      }, {
        default: _withCtx(function () {
          return [_hoisted_41];
        }),
        _: 1
      })])];
    }),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_overlay, {
    show: $data.showFails,
    "z-index": "3",
    onClick: _cache[13] || (_cache[13] = function ($event) {
      return $data.showFails = false;
    })
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", {
        class: "overlay-wrapper fails",
        onClick: _cache[12] || (_cache[12] = _withModifiers(function () {
          return $options.checkDetail && $options.checkDetail.apply($options, arguments);
        }, ["stop"]))
      }, [_createElementVNode("p", null, _toDisplayString($data.errorInfo), 1), _hoisted_42, _createVNode(_component_van_button, {
        class: "button-wrapper",
        block: "",
        type: "primary",
        size: "normal",
        round: "",
        color: "linear-gradient(180deg, #FF9D9D 0%, #CF0000 100%)"
      }, {
        default: _withCtx(function () {
          return [_hoisted_43];
        }),
        _: 1
      })])];
    }),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_overlay, {
    show: $data.showTip,
    "z-index": "3",
    onClick: _cache[16] || (_cache[16] = function ($event) {
      return $data.showTip = false;
    })
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_44, [_createElementVNode("p", _hoisted_45, _toDisplayString($data.tipInfo), 1), _createElementVNode("div", _hoisted_46, [_createElementVNode("ul", null, [_createElementVNode("li", {
        onClick: _cache[14] || (_cache[14] = function ($event) {
          return $data.showTip = false;
        })
      }, [_createVNode(_component_van_button, {
        block: "",
        round: "",
        size: "normal",
        type: "primary",
        color: "#FC9224"
      }, {
        default: _withCtx(function () {
          return [_hoisted_47];
        }),
        _: 1
      })]), _createElementVNode("li", {
        onClick: _cache[15] || (_cache[15] = function () {
          return $options.onClickAuthentication && $options.onClickAuthentication.apply($options, arguments);
        })
      }, [_createVNode(_component_van_button, {
        block: "",
        plain: "",
        round: "",
        size: "normal",
        type: "primary",
        color: "#FC9224"
      }, {
        default: _withCtx(function () {
          return [_hoisted_48];
        }),
        _: 1
      })])])])])];
    }),
    _: 1
  }, 8, ["show"])])) : _createCommentVNode("", true);
}